/**
 * Seismic is a shielded EVM. A standard `eth_call` zeroes the `from` field on Seismic, so
 * `msg.sender` becomes `address(0)` during gas estimation and the Safe `execTransaction`
 * `require(msg.sender == owner || approvedHashes[...] != 0, "GS025")` reverts. All Seismic-specific
 * handling in this module is gated on this chain id (and/or the SHIELDED_EVM chain feature flag) so
 * every other chain is completely unaffected.
 */
/** Seismic testnet (Mercury). */
export const SEISMIC_TESTNET_CHAIN_ID = '5124'

/** Backwards-compatible alias for the testnet id. */
export const SEISMIC_CHAIN_ID = SEISMIC_TESTNET_CHAIN_ID

/**
 * All Seismic (shielded EVM) chain ids handled natively. Currently testnet only; the mainnet id will
 * be appended here once available. Membership in this set enables the signed-read / shielded-write
 * path; chains can alternatively opt in via the SHIELDED_EVM feature flag.
 */
export const SEISMIC_CHAIN_IDS: ReadonlySet<string> = new Set([SEISMIC_TESTNET_CHAIN_ID])

/**
 * Gas limit supplied for shielded `execTransaction` / `approveHash` writes. On Seismic we cannot run
 * a precise `eth_estimateGas` (it is a plain `eth_call` and reverts with GS025 due to the zeroed
 * `from`), so after validating the transaction with a signed read we supply a safe over-estimate.
 * Unused gas is refunded, so over-estimating is safe; this floor comfortably covers a Safe
 * `execTransaction` wrapping a native transfer plus Safe overhead.
 */
export const SHIELDED_EXEC_GAS_FLOOR = 500_000n

/** Extra gas added on top of the Safe's own `baseGas + safeTxGas` accounting. */
export const SHIELDED_EXEC_GAS_BUFFER = 250_000n
